export const PLANS = [
  {
    id: 'free',
    name: 'Free',
    priceLabel: '€0 / Monat',
    description: 'Unbegrenzt kostenfrei, ohne Abrechnung. Jobs werden nur gezählt.',
    quota: { type: 'unlimited', value: null },
    requiresBilling: false,
    visibleInStore: false,
  },
  {
    id: 'payg',
    name: 'Pay per Use',
    priceLabel: '€3 pro verarbeiteten Job',
    description: 'Flexible Nutzung ohne Grundgebühr, Abrechnung pro verarbeitetem Job.',
    quota: { type: 'per_job', value: null },
    requiresBilling: true,
    visibleInStore: true,
  },
  {
    id: 'package_m',
    name: 'Paket M · 10 Jobs',
    priceLabel: '€10 / Monat',
    description: 'Für Projektteams mit regelmäßigem Bedarf, 10 Jobs pro Monat.',
    quota: { type: 'monthly', value: 10 },
    requiresBilling: true,
    visibleInStore: true,
  },
  {
    id: 'unlimited',
    name: 'Unlimited',
    priceLabel: '€60 / Monat',
    description: 'Unbegrenzte Jobs für größere Teams, priorisierte Verarbeitung inklusive.',
    quota: { type: 'unlimited', value: null },
    requiresBilling: true,
    visibleInStore: true,
  },
];

export const DEFAULT_PLAN_ID = 'payg';

export const getPlanById = (planId) => PLANS.find((plan) => plan.id === planId) ?? null;
